/**
 * Created by sswaminathan on 1/8/22
 * File: LicenseProductContainer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css


/**
 *   TODO: Brief what is this component/class do
 */
import { useContext } from 'react'
import { Italic, Body } from '@panwds/react-ui'
import CheckBoxComponent from '../dataInput/CheckBoxComponent'
import LicenseCardHeader from '../LicenseCard/LicenseCardHeader'
import LicenseProductInfo from './LicenseProductInfo'
import LicenseProductLegend from './LicenseProductLegend'
import LicenseProductList from './LicenseProductList'
import AppContext from '../../../common/context/AppContext'

const LicenseProductContainer = (props) => {
  const { productInformation, licenseValue, allocation, handleProductSelection,
    handleAllocationOnChange, cgxProduct, editDisabled, ...rest } = props
  const { getAppName } = useContext(AppContext)
  return (
    <>
      { productInformation?.length && productInformation.map((each, index) => {
        return <fieldset
          key={index}
          className='tw-border tw-border-solid tw-border-black tw-mb-4 tw-border-opacity-30 tw-pb-6 tw-ml-3 tw-mr-3'>
          <LicenseProductLegend
            licenseDisplayName={each.licenseCardInfo.licenseDisplayName}
            licenseValue={licenseValue}
            showToggle={productInformation?.length && cgxProduct?.length}
            disable={editDisabled ? editDisabled[licenseValue] ?? false : false}
            handleProductSelection={handleProductSelection}/>
          <LicenseProductInfo item={each}
            licenseValue={licenseValue}
            handleAllocationOnChange={handleAllocationOnChange}
            allocation={allocation}
            isCgx={each.licenseCardInfo.licenseDisplayName === 'cgx'}
            { ...rest }/>
          <LicenseProductList
            productName={each.licenseCardInfo.licenseDisplayName}
            item={each}
            isCgx={each.licenseCardInfo.licenseDisplayName === 'cgx'}
            allocation={allocation}
            licenseValue={licenseValue}
            {...{ ...rest, productInformation } }/>
        </fieldset>
      })}
      {cgxProduct?.length > 0 && cgxProduct.map((each, index) => {
        return <fieldset
          key={index}
          className='tw-border tw-border-solid tw-border-black tw-mb-4 tw-border-opacity-30 tw-pb-6 tw-ml-3 tw-mr-3'>
          <LicenseProductLegend
            licenseDisplayName={each.licenseCardInfo.licenseDisplayName}
            licenseValue={each.licenseCardInfo.licenseId}
            showToggle={productInformation.length && cgxProduct.length}
            handleProductSelection={handleProductSelection}
            disable={editDisabled[each.licenseCardInfo.licenseDisplayName] ?? false}
          />
          <LicenseCardHeader
            label={getAppName(each.licenseCardInfo.licenseDisplayName)}
            quantity={each.licenseCardInfo.licenseQuantity}
            location ={each.licenseCardInfo.serviceLocation}
            expiry ={each.licenseCardInfo.expiry}
            addons={each.licenseCardInfo.addOns}
            showImage={false}
            showAddOns={true}
          />
          <div className='tw-ml-2 tw-mt-2'>
            {each.addOns.length > 0 && <Body size='sm'><Italic>Add-ons Available:</Italic></Body>}
            {each.addOns.length > 0 && each.addOns.map((elem, inx) => {
              return <div key={inx} className='tw-mt-2'><CheckBoxComponent {...{ checkBoxLabelDesc: '', label: 'DVR' }}/></div>
            })}
          </div>
        </fieldset>
      })
      }
    </>
  )
}

LicenseProductContainer.propTypes = {}
export default LicenseProductContainer
